import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { step1Schema, step2Schema } from "./schemas";
import step2DefaultValue from "./step2DefaultValue";
import { OwnedBusinessEntitiesEditProps } from "./types";

export const useEditForm = ({
  defaultValues,
  applicationing,
}: {
  defaultValues: Omit<
    OwnedBusinessEntitiesEditProps["ownedBusinessEntity"],
    "code" | "is_approved" | "is_active"
  >;
  applicationing: boolean;
}) => {
  return useForm({
    defaultValues: {
      ...defaultValues,
      logo_image: defaultValues.logo_image,
      contractor_info_attributes: defaultValues.contractor_info_attributes
        ? {
            ...defaultValues.contractor_info_attributes,
            architectural_design_works_attributes:
              defaultValues.contractor_info_attributes?.architectural_design_works_attributes?.map(
                (work) => ({
                  ...work,
                  above_ground_floors:
                    work.above_ground_floors?.toString() ?? "",
                  underground_floors: work.underground_floors?.toString() ?? "",
                  total_floor_area: work.total_floor_area?.toString() ?? "",
                  completion_year: work.completion_year?.toString() ?? "",
                }),
              ) ?? [],
          }
        : {
            ...step2DefaultValue.contractor_info_attributes,
            contractor_info_supported_building_types_attributes: [
              { building_type_id: "", structure_type_ids: [] as string[] },
            ],
          },
      client_info_attributes: defaultValues.client_info_attributes
        ? defaultValues.client_info_attributes
        : step2DefaultValue.client_info_attributes,
    },
    resolver: yupResolver(step1Schema.concat(step2Schema)),
    disabled: applicationing,
  });
};
